import {
	SET_ACTIVE_CURRENCY,
} from '../actions/setActiveCurrency'

import merge from 'lodash/merge'

const initialState = {
}

export default function activeCurrencyReducer(state = initialState, action) {
	switch(action.type) {

		case SET_ACTIVE_CURRENCY:
			// Select activeRoom manually
			return merge({}, state, action.payload)

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/activeCurrencyReducers.js